import { useSearchParams } from "react-router-dom"

const useGetSearchParams = (key) => {
    const getSearhcParams = useSearchParams()[0]
    const param = getSearhcParams.get(key)

    return param
}

export default useGetSearchParams